module.exports = __webpack_public_path__ + "images/category_lp/watch/store_images/5_16b0d0692910ec76905364dbb1956eab.png";